// 全局配置菜单文件
// 后台logo配置 navBar后台菜单配置
export default {
	logo: '千峰云管理系统',
	navBar: {
		active: '0',
		list: [{
				name: "首页",
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-home",
					name: "后台首页",
					pathname: "index"
				}, {
					icon: "el-icon-picture",
					name: "相册管理",
					pathname: "image"
				}, {
					icon: "el-icon-s-claim",
					name: "系统公告",
					pathname: "xtgl_xtxx_xtgg"
				}, {
					icon: "el-icon-s-claim",
					name: "批次号",
					pathname: "xtgl_qtgn_pch"
				}]
			},
			{
				name: "商品",
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-claim",
					name: "商品列表",
					pathname: "shop_goods_list"
				},{
					icon: "el-icon-s-help",
					name: "分类管理",
					pathname: "shop_category_list"
				},{
					icon: "el-icon-s-order",
					name: "商品规格",
					pathname: "shop_sku_list"
				},{
					icon: "el-icon-menu",
					name: "商品类型",
					pathname: "shop_type_list"
				},{
					icon: "el-icon-edit-outline",
					name: "商品评论",
					pathname: "shop_comment_list"
				},{
					icon: "el-icon-edit-outline",
					name: "编辑货物",
					pathname: "zlgl_cpzl_cpgl_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "货物管理",
					pathname: "zlgl_cpzl_cpgl"
				},
				{
					icon: "el-icon-edit-outline",
					name: "BOM设置",
					pathname: "zlgl_cpzl_cpgl_bom"
				},
				{
					icon: "el-icon-edit-outline",
					name: "客户资料",
					pathname: "zjb_khzl"
				},
				{
					icon: "el-icon-edit-outline",
					name: "销售下单",
					pathname: "xsgl_ddcl_xsdd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "销售出库下单",
					pathname: "xsgl_ddcl_xsckd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "销售退货下单",
					pathname: "xsgl_ddcl_xsthd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "货运站点",
					pathname: "zlgl_jczl_thzd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "销售订单",
					pathname: "xsgl_ddcl_xsdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "出仓下单",
					pathname: "ccgl_ddcl_ccdd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "采购入库下单",
					pathname: "cggl_ddcl_cgrk_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "采购退货下单",
					pathname: "cggl_ddcl_cgthd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "采购订单",
					pathname: "cggl_ddcl_cgdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "调拨下单",
					pathname: "ckgl_ckcl_dbd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "调拨单",
					pathname: "ckgl_ckcl_dbd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "盘点下单",
					pathname: "ckgl_ckcl_pdd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "盘点单",
					pathname: "ckgl_ckcl_pdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "组装下单",
					pathname: "ckgl_ckcl_zzd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "组装单",
					pathname: "ckgl_ckcl_zzd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "拆卸下单",
					pathname: "ckgl_ckcl_cxd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "拆卸单",
					pathname: "ckgl_ckcl_cxd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "损耗下单",
					pathname: "ckgl_ckcl_shd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "损耗单",
					pathname: "ckgl_ckcl_shd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "期初库存",
					pathname: "ckgl_ckxx_qckc"
				},
				{
					icon: "el-icon-edit-outline",
					name: "录入库存",
					pathname: "ckgl_ckxx_qckc_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "仓库明细",
					pathname: "ckgl_ckxx_ckmx"
				},
				{
					icon: "el-icon-edit-outline",
					name: "库存流水",
					pathname: "ckgl_ckxx_kcls"
				},
				{
					icon: "el-icon-edit-outline",
					name: "添加生产订单",
					pathname: "scgl_scrw_scxd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "生产下单",
					pathname: "scgl_scrw_scxd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "生产订单",
					pathname: "scgl_scrw_scdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "生产领料下单",
					pathname: "scgl_scrw_scll_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "生产领料",
					pathname: "scgl_scrw_scll"
				},
				{
					icon: "el-icon-edit-outline",
					name: "生产退料料下单",
					pathname: "scgl_scrw_sctl_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "生产退料",
					pathname: "scgl_scrw_sctl"
				},
				{
					icon: "el-icon-edit-outline",
					name: "成品入库下单",
					pathname: "scgl_zjhrk_cprk_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑代付订单",
					pathname: "djgl_ddcl_dfdd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "成品入库",
					pathname: "scgl_zjhrk_cprk"
				},
				{
					meta:{title:'BOM设置'},
					component:'zlgl_cpzl_cpgl_bom'
				},
				{
					meta:{title:'任务列表'},
					component:'rwlc_rwlc_rwlb'
				},
				{
					meta:{title:'部门机构'},
					component:'xtgl_jsry_bmjg'
				},
				{
					meta:{title:'添加客户'},
					component:'khgl_khgl_khxx_create'
				},
				{
					meta:{title:'查看客户'},
					component:'khgl_khgl_khxx_ck'
				},
				{
					meta:{title:'转移客户'},
					component:'khgl_khgl_khxx_zykh'
				},
				{
					meta:{title:'计费配置'},
					component:'khgl_khgl_khxx_jfpz'
				},
				{
					meta:{title:'客户资料'},
					component:'khgl_khgl_khxx_khzl'
				},
				{
					meta:{title:'客户信息'},
					component:'khgl_khgl_khxx'
				},
				{
					meta:{title:'开票信息'},
					component:'khgl_khgl_khxx_kpxx'
				},
				{
					meta:{title:'制作MRP单'},
					component:'scgl_scrw_mrp_create'
				},
				{
					meta:{title:'MRP单'},
					component:'scgl_scrw_mrp'
				},
				
				
				{
					icon: "el-icon-edit-outline",
					name: "部署流程",
					pathname: "zjb_bslc"
				},
				{
					icon: "el-icon-edit-outline",
					name: "执行流程",
					pathname: "zjb_zxlc"
				},
				{
					icon: "el-icon-edit-outline",
					name: "查看关联",
					pathname: "zjb_ckgl"
				},
				{
					icon: "el-icon-edit-outline",
					name: "添加销售出库",
					pathname: "zjb_tjxsck"
				},
				{
					icon: "el-icon-edit-outline",
					name: "添加采购入库",
					pathname: "zjb_tjcgrk"
				},
				{
					icon: "el-icon-edit-outline",
					name: "添加生产订单",
					pathname: "zjb_tjscdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "打印报表",
					pathname: "zjb_dybb"
				},
				{
					icon: "el-icon-edit-outline",
					name: "打印",
					pathname: "zjb_dybb_dy"
				},
				{
					icon: "el-icon-edit-outline",
					name: "制定MRP",
					pathname: "zjb_zdmrp"
				},
				{
					icon: "el-icon-edit-outline",
					name: "添加部门",
					pathname: "zjb_bmjg"
				},
				
				{
					icon: "el-icon-edit-outline",
					name: "收款订单",
					pathname: "cwgl_srjz_shqk"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑收款订单",
					pathname: "cwgl_srjz_shqk_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "预收款订单",
					pathname: "cwgl_srjz_yskdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑预收款订单",
					pathname: "cwgl_srjz_yskdd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "收回欠款",
					pathname: "cwgl_srjz_shqk"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑收回欠款",
					pathname: "cwgl_srjz_shqk_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "退还收入",
					pathname: "cwgl_srjz_thsr"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑退还收入",
					pathname: "cwgl_srjz_thsr_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "借入/收押金等",
					pathname: "cwgl_srjz_jr"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑借入/收押金等",
					pathname: "cwgl_srjz_jr_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "转账取存",
					pathname: "cwgl_srjz_zzqc"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑转账取存",
					pathname: "cwgl_srjz_zzqc_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "付款订单",
					pathname: "cwgl_zcjz_fkdd"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑付款订单",
					pathname: "cwgl_zcjz_fkdd_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "偿还欠款",
					pathname: "cwgl_zcjz_chqk"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑偿还欠款",
					pathname: "cwgl_zcjz_chqk_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "退还支出",
					pathname: "cwgl_zcjz_thzc"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑退还支出",
					pathname: "cwgl_zcjz_thzc_create"
				},
				{
					icon: "el-icon-edit-outline",
					name: "借出/交押金等",
					pathname: "cwgl_zcjz_jc"
				},
				{
					icon: "el-icon-edit-outline",
					name: "编辑借出/交押金等",
					pathname: "cwgl_zcjz_jc_create"
				},
				]
			},
			{
				name: "订单",
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-order",
					name: "订单列表",
					pathname: "order_order_list"
				},{
					icon: "el-icon-s-ticket",
					name: "发票管理",
					pathname: "order_invoice_list"
				},{
					icon: "el-icon-s-custom",
					name: "售后服务",
					pathname: "order_after-sale_list"
				},]
			},
			{
				name: "会员",
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-custom",
					name: "会员列表",
					pathname: "user_user-list_list"
				},{
					icon: "el-icon-medal-1",
					name: "会员等级",
					pathname: "user_user-level_list"
				},]
			},
			{
				name: "设置",
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-tools",
					name: "基础设置",
					pathname: "set_base"
				},{
					icon: "el-icon-truck",
					name: "物流设置",
					pathname: "set_express"
				},{
					icon: "el-icon-s-platform",
					name: "管理员列表",
					pathname: "set_manager"
				},{
					icon: "el-icon-s-finance",
					name: "交易设置",
					pathname: "set_payment"
				},]
			},
		]
	}

}
